<!-- Displays the About statment, address, hours, and phone (if given) for a location. Google
     map is also displayed.
-->

<template>
  <main class="my-3">
    <mdb-card v-if="!loading" class="animated bounce">
      <mdb-card-header>Contact Information</mdb-card-header>
      <mdb-card-body>
        
        <!--Contact information formatted-->

        <mdb-row>

          <mdb-col>
            <mdb-card-title>{{contact_info.contact_name}}</mdb-card-title>
            <mdb-card-text>{{contact_info.contact_about}}</mdb-card-text>
          </mdb-col>
        </mdb-row>
        <mdb-row>

          <!--Address with all available extra information. Each office gets its own address section.-->

          <mdb-col v-for="(office, i) in contact_info.contact_content" :key="i" lg="12" class="mb-3">
            <OfficeInfo :block="office" :name="contact_info.contact_name" :about="contact_info.contact_about"></OfficeInfo>
          </mdb-col>
        </mdb-row>  
      </mdb-card-body>
    </mdb-card>
  </main>
</template>

<script>
import {
  mdbCard,
  mdbCardHeader,
  mdbCardBody,
  mdbCardTitle, 
  mdbCardText,
  mdbRow,
  mdbCol
} from "mdbvue"
import OfficeInfo from "@/views/contact/OfficeInfo.vue";
export default {
  name: "ContactTabView",
  components: {
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbRow,
    mdbCol,
    OfficeInfo
  },  
  data() {
    return {
      loading: false,
    };
  },
  props: {
    contact_info: {type: [Boolean,Object]}
  },
  watch: {
    contact_info: function(){
      this.loading = true
      process.nextTick(function() {this.loading = false}.bind(this));
    }
  }
}
</script>